import * as types from "./types";
import * as commonTypes from "../common/types";

export default (state = {}, action) => {
  switch (action.type) {
    case commonTypes.ASYNC_START: {
      if (!types[action.waiting]) {
        return state;
      }
      return {
        ...state,
        loading: true,
        waiting: action.waiting,
        action: commonTypes.ASYNC_START,
      };
    }
    case commonTypes.ASYNC_END: {
      if (!types[action.done]) {
        return state;
      }

      return {
        ...state,
        waiting: null,
        loading: false,
        action: commonTypes.ASYNC_END,
      };
    }
    case types.LIST_CUSTOMER: {
      return {
        ...state,
        action: types.LIST_CUSTOMER,
        customers: action.status ? action.payload.customers : [],
        totalRecord: action.status ? action.payload.total_record : 0,
        totalPage: action.status ? action.payload.total_page : 0,
        status: action.status,
        message: action.message,
      };
    }
    case types.SHOW_CUSTOMER: {
      return {
        ...state,
        action: types.SHOW_CUSTOMER,
        customer: action.status ? action.payload.customer : {},
        status: action.status,
        message: action.message,
      };
    }
    case types.SEARCH_CUSTOMER: {
      return {
        ...state,
        action: types.SEARCH_CUSTOMER,
        customers: action.status ? action.payload.customers : [],
        status: action.status,
        message: action.message,
      };
    }
    case types.DELETE_CUSTOMERS: {
      return {
        ...state,
        action: types.DELETE_CUSTOMERS,
        status: action.status,
        message: action.message,
      };
    }
    case types.DELETE_CUSTOMER: {
      return {
        ...state,
        action: types.DELETE_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.CREATE_CUSTOMER: {
      return {
        ...state,
        action: types.CREATE_CUSTOMER,
        customer: action.status ? action.payload.customer : {},
        status: action.status,
        message: action.message,
      };
    }
    case types.UPDATE_CUSTOMER: {
      return {
        ...state,
        action: types.UPDATE_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.RELOAD_CUSTOMER: {
      return {
        ...state,
        action: types.RELOAD_CUSTOMER,
        customer: action.status ? action.payload.customer : {},
        status: action.status,
        message: action.message,
      };
    }
    case types.IMPORT_CUSTOMER: {
      return {
        ...state,
        action: types.IMPORT_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.EXPORT_CUSTOMER: {
      return {
        ...state,
        action: types.EXPORT_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.APPLY_DEFAULT_ADDRESS_CUSTOMER: {
      return {
        ...state,
        action: types.APPLY_DEFAULT_ADDRESS_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.UPDATE_CUSTOM_FIELD_BY_CUSTOMER: {
      return {
        ...state,
        action: types.UPDATE_CUSTOM_FIELD_BY_CUSTOMER,
        status: action.status,
        message: action.message,
      };
    }
    case types.VERIFY_ACCOUNT: {
      return {
        ...state,
        action: types.VERIFY_ACCOUNT,
        status: action.status,
        message: action.message,
      };
    }
    case types.GET_PASSWORD_TOKEN: {
      return {
        ...state,
        action: types.GET_PASSWORD_TOKEN,
        password_token: action.status ? action.payload.token : "",
        status: action.status,
        message: action.message,
      };
    }
    default:
      return state;
  }
};
